<div
  class="grid h-[100dvh] min-h-0 overflow-hidden transition-[grid-template-columns] duration-300 gap-x-2 sm:gap-x-3 bg-[#FCFCFD] dark:bg-[#0C0C1A]"
  [ngClass]="{
    'grid-cols-[16rem_minmax(0,1fr)]': isSidebarExpanded,
    'grid-cols-[6rem_minmax(0,1fr)]': !isSidebarExpanded
  }"
>
  <!-- Sidebar -->
  <div
    class="transition-all duration-300 h-full min-h-0 w-full border-r border-[#EDEAF0] dark:border-[#303049] overflow-hidden"
  >
    <app-sidebar
      [isExpanded]="isSidebarExpanded"
      (toggleSidebar)="onToggleSidebar()"
      (titleChange)="atualizarTitulo($event)"
    ></app-sidebar>
  </div>

  <!-- Conteúdo principal -->
  <div class="flex flex-col h-full min-h-0 w-full min-w-0 overflow-visible">
    <!-- Navbar -->
    <div class="relative z-[100] shrink-0 px-3 sm:px-6">
      <app-navbar [title]="tituloAtual"></app-navbar>
    </div>

    <!-- Área dinâmica -->
    <div class="flex-1 min-h-0 min-w-0 overflow-hidden px-2 sm:px-4 pb-0">
      <div
        class="area-dinamica-container flex-1 w-full min-w-0 bg-transparent border-0 shadow-none rounded-none p-3 sm:p-6 min-h-0 overflow-hidden flex flex-col"
      >
        <!-- IMPORTANTE: outlet precisa crescer e permitir scroll interno dos filhos -->
        <div class="flex-1 min-h-0 min-w-0 overflow-hidden flex flex-col">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
